import CONFIG from "../../URL/index";
const axios = CONFIG.axios;
export default {
  services: {
    /*uploadFile: (file, queryString, token = "") => {
      return axios(token).post(`/upload${queryString ? `?${queryString}` : ""}`, file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },*/
    uploadFile: (formData, queryString, apiKey = "") => {
      return axios(`Bearer ${apiKey}`).post(`https://api.upload.io/v2/accounts/FW25b8h/uploads/form_data${queryString ? `?${queryString}` : ""}`, formData);
    },
  },
};
